
import React, { useEffect, useState } from "react";
import * as jnb from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import { FaHandPointRight } from "react-icons/fa";
import { config } from "../../../CommonUtils/CommonUrl/CommonUrls";
import { CommonPageHeading } from "../../../CommonUtils/CommonHeading/CommonPageHeading";
import Header from "../../../Header/Header";
import { CommonAxiosGet } from "../../../CommonUtils/CommonAxios/CommonAxios";
import { useSelector } from "react-redux";

export default function PayReport() {
    const loginreducer = useSelector((state) => state?.reducers?.loginreducer?.loginDetails?.loginData);
    const [showData, setData] = useState([])
    const navigate = useNavigate()
    function getDataFunction() {
        let url = config.url.BOC_URL + "workerreg?aadhaarNo=" + loginreducer?.loginData?.mask_aadhaar ;
        CommonAxiosGet(url).then((response) => {
            if (response.data.status === true) {
                setData(response.data.workerReg);
            }
            else {
                setData([])
            }
        })
    };
    useEffect(() => {
        getDataFunction()
    }, [])
    function navcesspaymntform() {
        navigate("/CessPaymentDetails");
    }

    return (
        <React.Fragment>
            <Header />
            <div className="main_section"> </div>
            <CommonPageHeading heading="CESS Payment Report" />
            <jnb.Container className="outer-page-content-container" >

                <div className="px-2 mt-2 text-right" onClick={() => navcesspaymntform()}>
                    <FaHandPointRight></FaHandPointRight>&nbsp;
                    <span className="text-decoration-underline">Click here to apply</span> &nbsp;
                    <i className="badge badge-success forgot mb-4 fw-bold " data-toggle="tooltip" animation="true" title="Click Me!"
                    > New Payment</i>
                </div>

                <div className="form-card-jnb" >
                    <jnb.Row className="pt-1">
                        <div className="table-responsive">
                            <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-0"
                                style={{ border: '2px solid lightblue', width: '100%', borderCollapse: 'collapse', }}
                            >
                                {showData?.length > 0 ?
                                    <thead style={{ border: "1px solid black" }}>
                                        <tr>
                                            <th rowSpan={2}>S.NO</th>
                                            <th rowSpan={2}>Establishment ID</th>
                                            <th rowSpan={2}>Establishment name</th>
                                            <th rowSpan={2}>Establishment Category</th>
                                            <th rowSpan={2}>Address</th>
                                            <th colSpan={3}>Estimated Cost</th>
                                            <th colSpan={3}>CESS Amount</th>
                                            <th rowSpan={2}>Status</th>
                                        </tr>
                                        <tr>
                                            <th>Total</th>
                                            <th>Paid</th>
                                            <th>To be Paid</th>
                                            <th>Total</th>
                                            <th>Paid</th>
                                            <th>To be Paid</th>
                                        </tr>
                                    </thead>
                                    :

                                    <div className="text-center">
                                        <span className="centered-red-text">***********   No Data Found   ************</span>

                                    </div>

                                }

                                <tbody>

                                    {showData?.map((data, index) => {
                                        return (
                                            <tr key={index} id={index}>
                                                <td>{index + 1}</td>
                                                <td>{data?.est_reg_id}</td>
                                                <td>{data?.establishment_name}</td>
                                                <td>{data?.establishment_category}</td>
                                                <td>{data?.manager_address}, Door No-{data?.manager_door_no} ,
                                                    {data?.manager_village_name},
                                                    {data?.manager_mandal_name} ,
                                                    {data?.manager_district_name} dist.,
                                                    {data?.manager_pincode}</td>
                                                <td className="text-right">{data?.est_cost_of_construction}</td>
                                                <td className="text-right">{data?.further_cost_paid}</td>
                                                <td className="text-right">{data?.further_cost_to_be_paid}</td>
                                                <td className="text-right">{data?.tot_cess}</td>
                                                <td className="text-right">{data?.cess_paid}</td>
                                                <td className="text-right">{data?.cess_to_be_paid}</td>
                                                {
                                                    data?.cess_to_be_paid === 0 ? <td className="text-success fw-bold" style={{textDecoration:"underline"}} onClick={()=>{navigate("/CessPaymentDetails",{state:{status:"S",data:data}})}}>Success</td> : 
                                                    <td onClick={()=>{navigate("/CessPaymentDetails",{state:{status:"P",data:data}})}} style={{textDecoration:"underline"}} className="text-danger fw-bold">Pending</td>
                                                }
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>

                    </jnb.Row>
                </div>

            </jnb.Container>
        </React.Fragment>

    )
}